<template>

  <div class="mt-4">
    <div v-if="isLoading" class="loading-overlay">
      <div class="spinner-border text-light" role="status"></div>
      <p>Cargando...</p>
    </div>
    <!-- Page Header -->
    <div class="page-header">
      <h1 class="page-header-title"><i class="bi bi-file-earmark-text me-2"></i>Listado de Envíos Locales — Documentos</h1>
    </div>

    <!-- Filtros -->
    <div class="filter-card">
      <div class="row g-2">
        <div class="col-md-3 d-none d-md-block">
          <label class="form-label">RUC</label>
          <input type="text" class="form-control form-control-sm" v-model="filtros.ruc" placeholder="Ingrese RUC" />
        </div>
        <div class="col-md-3 d-none d-md-block">
          <label class="form-label">Razón Social</label>
          <input type="text" class="form-control form-control-sm" v-model="filtros.razon_social" placeholder="Razón social..." />
        </div>
        <div class="col-12 col-md-3">
          <label class="form-label">Cliente Final</label>
          <input type="text" class="form-control form-control-sm" v-model="filtros.cliente_final" placeholder="Cliente final..." />
        </div>
        <div class="col-md-3 d-none d-md-block">
          <label class="form-label">Área Solicitante</label>
          <select class="form-select form-select-sm" v-model="filtros.cod_metodo_envio_id">
            <option v-for="item in codigosMetodoEnvio" :key="item.id" :value="item.id">{{ item.codigo }}</option>
          </select>
        </div>
        <div class="col-md-3 d-none d-md-block">
          <label class="form-label">N° Orden de Compra</label>
          <input type="text" class="form-control form-control-sm" v-model="filtros.pedido" placeholder="N° Orden..." />
        </div>
        <div class="col-md-3 d-none d-md-block">
          <label class="form-label">N° Factura</label>
          <input type="text" class="form-control form-control-sm" v-model="filtros.guia" placeholder="N° Factura..." />
        </div>
        <div class="col-12 col-md-3">
          <label class="form-label">Rango de Fechas</label>
          <div class="row gx-1">
            <div class="col-6"><input type="date" class="form-control form-control-sm" v-model="filtros.fecha_inicio" /></div>
            <div class="col-6"><input type="date" class="form-control form-control-sm" v-model="filtros.fecha_fin" /></div>
          </div>
        </div>
        <div class="col-md-3 d-none d-md-block">
          <label class="form-label">Estado</label>
          <select class="form-select form-select-sm" v-model="filtros.estado_entrega">
            <option value="">Todos</option>
            <option v-for="item in estadosEnvio" :value="item.id" :key="item.id">{{ item.nombre_documentos }}</option>
          </select>
        </div>
        <div class="col-md-2 d-none d-md-block">
          <label class="form-label">OTM</label>
          <input type="text" class="form-control form-control-sm" v-model="filtros.otm" placeholder="N° OTM..." />
        </div>
        <div class="col-md-2 d-none d-md-block" v-if="esSuperAdmin()">
          <label class="form-label">Modalidad</label>
          <select class="form-select form-select-sm" v-model="filtros.modalidad_envio">
            <option value="">Todos</option>
            <option value="CONSOLIDADO">CONSOLIDADO</option>
            <option value="EXCLUSIVO">EXCLUSIVO</option>
          </select>
        </div>
        <!-- Los botones se ubican en la última fila de filtros si hay espacio (una fila menos) -->
        <div class="col-12 col-md-auto ms-auto d-flex justify-content-end align-items-end">
          <div class="filter-actions">
            <button class="btn-filter" @click="aplicarFiltros"><i class="bi bi-search"></i> Buscar</button>
            <button class="btn-clear" @click="limpiarFiltros()"><i class="bi bi-x-circle"></i> Limpiar</button>
            <button class="btn-export" @click="exportarExcel" :disabled="exportando" title="Exporta hasta 2 meses (facturación mensual)">
              <span v-if="exportando" class="spinner-border spinner-border-sm" role="status"></span>
              <i v-else class="bi bi-file-earmark-excel"></i>
              {{ exportando ? 'Exportando…' : 'Exportar' }}
            </button>
          </div>
        </div>
      </div>

    </div>

    <div class="table-responsive text-nowrap d-none d-md-block">
      <table class="table table-font-small table-bordered">
        <thead>
          <tr>
            <th>Rastreo</th>
            <th>Fecha Salida</th>
            <th>Fecha Entrega</th>
            <th>Area Solicitante</th>
            <th>Factura</th>
            <th>Orden de Compras</th>
            <th>OTM</th>
            <th>RUC Remitente</th>
            <th>Remitente Cliente Inicial-Final</th>
            <th>RUC Destinatario</th>
            <th>Destinatario Cliente Inicial-Final</th>
            <th>Estado</th>
            <th class="col-acciones">Acciones</th>
          </tr>
        </thead>
        <tbody class="table-border-bottom-0 padding-custom">
          <tr v-for="(envio, index) in envios" :key="index">
            <td class="celda-id"><a :href="`/tracking-local?numeroRastreo=${envio.rastreo}`">
                {{ envio.rastreo }}
              </a>
            </td>
            <td class="celda-id">{{ formatFecha(envio.fecha_salida) }}</td>
            <td class="celda-id">{{ formatFecha(envio.fecha_entrega) }}</td>
            <td>{{ envio.metodo_envio }}</td>
            <td>{{ envio.detalles.length>1?'VARIAS FACTURAS':envio.facturas_concatenadas }}</td>
            <td>{{ envio.detalles.length>1?'VARIAS OC':envio.oc_concatenadas }}</td>
            <td>{{ envio.detalles.length>1?'VARIAS OTM':envio.otm_concatenadas }}</td>
            <td class="celda-id">{{ envio.ruc_remitente }}</td>
            <td class="celda-entidad"><div class="entidad-nombre" :title="envio.empresa_sucursal">{{ envio.empresa_sucursal }}</div></td>
            <td class="celda-id">{{ envio.ruc_destinatario }}</td>
            <td class="celda-entidad"><div class="entidad-nombre" :title="envio.empresa_sucursal_destino">{{ envio.empresa_sucursal_destino }}</div></td>
            <td class="p-1">
              <span :class="getBadgeClass(envio.estado_entrega)" @click="openEstadoEnvio(envio)">
                {{ envio.estado_envio_documento }}
              </span>
            </td>
            <td class="col-acciones position-relative">
              <div class="btn-group">
                <button class="btn-acciones dropdown-toggle" type="button" title="Acciones" aria-label="Acciones" data-bs-toggle="dropdown"
                  aria-expanded="false">
                  <i class="bi bi-three-dots-vertical"></i>
                  <!-- Icono de tres puntos -->
                </button>
                <ul class="dropdown-menu dropdown-menu-end custom-dropdown" data-bs-popper="static">
                  <li>
                    <a class="dropdown-item" href="#" @click.prevent="mostrarDetalle(envio)">
                      <i class="bi bi-search text-dark"></i>
                      Mostrar detalles
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="#" @click.prevent="editarEnvio(envio)">
                      <i class="bi bi-pencil text-dark"></i>
                      Editar envío
                    </a>
                  </li>
                  <li v-if="esSuperAdmin()">
                    <a class="dropdown-item" href="#" @click.prevent="abrirGestionarModal(envio)">
                      <i class="bi bi-list-task text-dark"></i>
                      Gestionar
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="#" @click.prevent="eliminarEnvio(envio)">
                      <i class="bi bi-trash text-dark"></i>
                      Eliminar
                    </a>
                  </li>
                  <li v-if="esSuperAdmin()">
                    <a class="dropdown-item" href="#" @click.prevent="abrirCargarArchivosModal(envio)">
                      <i class="bi bi-upload text-dark"></i>
                      Documentos
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="#" @click.prevent="abrirGestionGuiasModal(envio)">
                      <i class="bi bi-file-text text-dark"></i>
                      Gestión de Cargos
                    </a>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- VISTA EN CARDS (solo en móviles) -->
    <div class="d-block d-md-none">
      <div v-for="(envio, index) in envios" :key="index" class="card mb-2 shadow-sm">
        <div class="card-body p-2">
          <div @click.prevent="mostrarDetalle(envio)">
          <h6 class="card-title fw-bold mb-2">
            Cliente: {{ envio.empresa_sucursal_destino }}
          </h6>
          <p class="mb-1"><strong>Rastreo:</strong> <a :href="`/tracking-local?numeroRastreo=${envio.rastreo}`">{{ envio.rastreo }}</a></p>
          <p class="mb-1"><strong>Detalle:</strong> {{ envio.detalles && envio.detalles.length > 0 && envio.detalles[0].detalle_metodo_envio ? envio.detalles[0].detalle_metodo_envio : 'Sin detalle' }}</p>
          <p class="mb-1"><strong>Fecha Salida:</strong> {{ formatFecha(envio.fecha_salida) }} {{
            formatHoraAMPM(envio.hora_salida) }}</p>
          <p class="mb-1"><strong>Fecha Entrega:</strong> {{ formatFecha(envio.fecha_entrega) }} {{
            formatHoraAMPM(envio.hora_llegada_maxima) }}</p>
          <p class="mb-1"><strong>Factura:</strong> {{ envio.detalles.length>1?'VARIAS FACTURAS':envio.facturas_concatenadas }}</p>
          <p class="mb-1"><strong>OTM:</strong> {{ envio.detalles.length>1?'VARIAS OMT':envio.otm_concatenadas }}</p>
          </div>
          <p class="mb-1"><strong>Estado:</strong>
            <span :class="getBadgeClass(envio.estado_entrega)" @click="openEstadoEnvio(envio)">
              {{ envio.estado_envio_documento }}
            </span>
          </p>
          <div class="btn-group w-100 mt-2">
            <button class="btn btn-outline-dark btn-sm dropdown-toggle w-100" type="button" data-bs-toggle="dropdown">
              <i class="bi bi-three-dots-vertical"></i> Opciones
            </button>
            <ul class="dropdown-menu w-100">
              <li>
                <a class="dropdown-item" href="#" @click.prevent="mostrarDetalle(envio)">
                  <i class="bi bi-search text-dark"></i> Mostrar detalles
                </a>
              </li>
              <li v-if="esAdmin()">
                <a class="dropdown-item" href="#" @click.prevent="editarEnvio(envio)">
                  <i class="bi bi-pencil text-dark"></i> Editar envío
                </a>
              </li>
              <li v-if="esAdmin()">
                <a class="dropdown-item" href="#" @click.prevent="abrirGestionarModal(envio)">
                  <i class="bi bi-list-task text-dark"></i> Gestionar
                </a>
              </li>
              <li v-if="esAdmin()">
                <a class="dropdown-item" href="#" @click.prevent="abrirCargarArchivosModal(envio)">
                  <i class="bi bi-upload text-dark"></i> Cargar archivos
                </a>  
              </li>
              <li>
                <a class="dropdown-item" href="#" @click.prevent="abrirGestionGuiasModal(envio)">
                  <i class="bi bi-file-text text-dark"></i> Gestión de Guías
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Paginación (25 por página, viene paginado desde el backend) -->
    <PaginacionListado :pagina="pagina" :total-paginas="totalPaginas" :total="totalEnvios" :por-pagina="porPagina"
      :en-pagina="envios.length" :cargando="isLoading" etiqueta="envíos" @cambiar="cambiarPagina" />

    <div v-if="modalGestionANW" id="modalGestionANW" class="modal fade show d-block" tabindex="-1">
      <div class="modal-dialog modal-xl">
        <div class="modal-content shadow-lg border-0">
          <!-- Encabezado -->
          <div class="modal-header">
            <h5 class="modal-title">Gestión del Envío</h5>
            <button type="button" class="btn-close" @click="modalGestionANW = false"></button>
          </div>
          <div class="modal-body p-4">
            <div class="mb-4">
              <ShippingANWLocalDocument ref="shippingANWRef" :envio="detalleEnvio"></ShippingANWLocalDocument>
            </div>
            <div class="mt-3 d-flex justify-content-end mb-3"><button @click="guardarGestion()" type="submit"
                class="btn btn-primary d-flex align-items-center gap-2"><i class="bi bi-floppy"></i> Guardar </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="modalDetalle" class="modal fade show d-block" tabindex="-1">
      <div class="modal-dialog modal-lg">
        <div class="modal-content shadow-lg border-0">
          <!-- Encabezado -->
          <div class="modal-header">
            <h5 class="modal-title">Detalles del Envío</h5>
            <button type="button" class="btn-close" @click="cerrarDetalle"></button>
          </div>

          <!-- Cuerpo del Modal -->
          <div class="modal-body p-4">
            <div class="d-none d-md-block">

              <!-- Datos Generales -->
              <div class="mb-4">
                <h6 class="fw-bold text-primary">Datos Generales</h6>
                <table class="table table-bordered table-sm">
                  <tbody>
                    <tr>
                      <td><strong>N° de Rastreo:</strong><br><a :href="`/tracking-local?numeroRastreo=${detalleEnvio.rastreo}`">{{ detalleEnvio.rastreo }}</a></td>
                      <td><strong>Area Solicitante:</strong><br>{{ detalleEnvio.metodo_envio }}</td>
                      <td><strong>Solicitante:</strong><br>{{ detalleEnvio.solicitante }}</td>
                      <td><strong>OTM:</strong><br>{{ detalleEnvio.otm_concatenadas }}</td>
                    </tr>
                    <tr>
                      <td><strong>Número Factura:</strong><br>{{ detalleEnvio.facturas_concatenadas }}</td>
                      <td><strong>Orden de Compra:</strong><br>{{ detalleEnvio.oc_concatenadas }}</td>
                      <td colspan="2"><strong>Documentos Extras:</strong><br>{{ detalleEnvio.doc_extras_concatenadas }}</td>
                    </tr>
                    <tr>
                      <td colspan="4"><strong>Observaciones:</strong><br>{{ detalleEnvio.observacion_final }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Información de Envío -->
              <div class="mb-4">
                <h6 class="fw-bold text-primary">Información de Envío</h6>
                <table class="table table-bordered table-sm">
                  <tbody>
                    <tr>
                      <td><strong>RUC Remitente:</strong><br>{{ detalleEnvio.ruc_remitente }}</td>
                      <td><strong>Remitente (Cliente Inicial - Final):</strong><br>{{ detalleEnvio.empresa_sucursal }}
                      </td>
                      <td><strong>Dirección:</strong><br>{{ detalleEnvio.sucursal_remitente.direccion }} - {{
                        detalleEnvio.sucursal_remitente.distrito_nombre }} -
                        {{ detalleEnvio.sucursal_remitente.provincia_nombre }}</td>
                    </tr>
                    <tr>
                      <td><strong>RUC Destinatario:</strong><br>{{ detalleEnvio.ruc_destinatario }}</td>
                      <td><strong>Destinatario (Cliente Inicial - Final):</strong><br>{{
                        detalleEnvio.empresa_sucursal_destino }}</td>
                      <td><strong>Dirección:</strong><br>{{ detalleEnvio.sucursal_destinatario.direccion }} - {{
                        detalleEnvio.sucursal_destinatario.distrito_nombre }} -
                        {{ detalleEnvio.sucursal_destinatario.provincia_nombre }}</td>
                    </tr>
                    <tr>
                      <td><strong>Tipo de Unidad:</strong><br>{{ detalleEnvio.tipo_unidad }}</td>
                      <td><strong>Fecha de Salida:</strong><br>{{ new
                        Date(detalleEnvio.fecha_salida).toLocaleDateString('es-ES') }}</td>
                      <td><strong>Fecha de Entrega:</strong><br>{{ new
                        Date(detalleEnvio.fecha_entrega).toLocaleDateString('es-ES') }}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Horario de Salida:</strong><br>
                        {{ new Date('1970-01-01T' + detalleEnvio.hora_salida).toLocaleTimeString('es-PE', {
                          hour:
                            '2-digit', minute: '2-digit', hour12: true
                        }) }}
                      </td>
                      <td>
                        <strong>Horario de Entrega:</strong><br>
                        {{ new Date('1970-01-01T' + detalleEnvio.hora_llegada_maxima).toLocaleTimeString('es-PE', {
                          hour:
                            '2-digit', minute: '2-digit', hour12: true
                        }) }}
                      </td>

                      <td><strong>Lead Time Esperado:</strong><br>{{ detalleEnvio.lead_time_esperado }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

             
            </div>
            <div class="d-block d-md-none">
              <!-- Datos Generales -->
              <h6 class="mt-4 fw-bold text-primary">Datos Generales</h6>
              <div class="card mb-2" v-if="detalleEnvio">
                <div class="card-body">
                  <p><strong>N° de Rastreo:</strong> <a :href="`/tracking-local?numeroRastreo=${detalleEnvio.rastreo}`">{{ detalleEnvio.rastreo }}</a></p>    
                  <p><strong>Area Solicitante:</strong>{{detalleEnvio.metodo_envio  }}</p>    
                  <p><strong>Solicitante:</strong>{{detalleEnvio.solicitante  }}</p>    
                  <p><strong>Detalle: </strong>{{ detalleEnvio.detalles && detalleEnvio.detalles.length > 0 && detalleEnvio.detalles[0].detalle_metodo_envio ? detalleEnvio.detalles[0].detalle_metodo_envio : 'Sin detalle' }}</p>              
                  <p><strong>Número Factura:</strong> {{ detalleEnvio.facturas_concatenadas }}</p>
                  <p><strong>Orden de Compra:</strong> {{ detalleEnvio.oc_concatenadas }}</p>
                  <p><strong>OTM:</strong> {{ detalleEnvio.otm_concatenadas }}</p>
                  <p><strong>Documentos Extras:</strong> {{ detalleEnvio.documentos_extras }}</p>
                  <p><strong>Observaciones:</strong> {{ detalleEnvio.observaciones }}</p>
                  <p><strong>Agencia:</strong> {{ detalleEnvio.agencia }}</p>
                </div>
              </div>

              <!-- Información de Envío -->
              <h6 class=" mt-4 fw-bold text-primary">Información de Envío</h6>
              <div class="card mb-2">
                <div class="card-body">
                  <p><strong>RUC Remitente:</strong> {{ detalleEnvio.ruc_remitente }}</p>
                  <p><strong>Remitente:</strong> {{ detalleEnvio.empresa_sucursal }}</p>
                  <p><strong>Dirección Remitente:</strong>
                    {{ detalleEnvio.sucursal_remitente.direccion }} -
                    {{ detalleEnvio.sucursal_remitente.distrito_nombre }} -
                    {{ detalleEnvio.sucursal_remitente.provincia_nombre }}
                  </p>
                  <p><strong>RUC Destinatario:</strong> {{ detalleEnvio.ruc_destinatario }}</p>
                  <p><strong>Destinatario:</strong> {{ detalleEnvio.empresa_sucursal_destino }}</p>
                  <p><strong>Dirección Destinatario:</strong>
                    {{ detalleEnvio.sucursal_destinatario.direccion }} -
                    {{ detalleEnvio.sucursal_destinatario.distrito_nombre }} -
                    {{ detalleEnvio.sucursal_destinatario.provincia_nombre }}
                  </p>
                  <p><strong>Tipo de Unidad:</strong> {{ detalleEnvio.tipo_unidad }}</p>
                  <p><strong>Fecha de Salida:</strong> {{ new
                    Date(detalleEnvio.fecha_salida).toLocaleDateString('es-ES')
                  }}</p>
                  <p><strong>Fecha de Entrega:</strong> {{ new
                    Date(detalleEnvio.fecha_entrega).toLocaleDateString('es-ES') }}</p>
                  <p><strong>Horario de Salida:</strong>
                    {{ new Date('1970-01-01T' + detalleEnvio.hora_salida).toLocaleTimeString('es-PE', {
                      hour: '2-digit', minute: '2-digit', hour12: true
                    }) }}
                  </p>
                  <p><strong>Horario de Entrega:</strong>
                    {{ new Date('1970-01-01T' + detalleEnvio.hora_llegada_maxima).toLocaleTimeString('es-PE', {
                      hour: '2-digit', minute: '2-digit', hour12: true
                    }) }}
                  </p>
                </div>
              </div>

           
            </div>
          </div>


        </div>
      </div>

    </div>

    <div v-if="modalEstados" class="modal fade show d-block" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="uploadModalLabel">Gestión de Estados</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" @click="modalEstados = false"
              aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <label for="">Estado del Envío</label>
                <select name="" id="" class="form-control" v-model="nuevoEstado">
                  <option v-for="item in estadosEnvio" :value="item.id" :key="item.id">{{ item.nombre_documentos }}
                  </option>
                </select>
              </div>
             
            </div>
            <div class="row mt-2">
              <div class="form-group" v-if="nuevoEstado == 10">
                <label for="tipoArchivo">Conformidad de Draeger (N°hojas)</label>
                <select v-model="conformidad_draeger" class="form-control" id="tipoArchivo">
                  <option value="SIN RECEPCIONAR">SIN RECEPCIONAR</option>
                  <option value="RECEPCIONADO">RECEPCIONADO</option>
                  <option value="OBSERVADO">OBSERVADO</option>
                </select>
              </div>

              <div class="form-group" v-if="nuevoEstado != 10 && nuevoEstado != 8">
                <label for="tipoArchivo">Tipo de Archivo</label>
                <select v-model="tipoArchivo" class="form-control" id="tipoArchivo">
                  <option value="">-- Selecciona un tipo --</option>
                  <option value="fotos">📸 Fotos (JPG / PNG)</option>
                  <option value="videos">🎥 Videos (MP4 / MOV / AVI)</option>
                  <option value="pdf">📄 PDF (escaneo o foto en PDF)</option>
                </select>
              </div>

              <div v-if="nuevoEstado == 7" class="row mt-2">
                <div class="col-md-12">
                  <label class="form-label">Conformidad de la entrega</label>
                  <select v-model="conformidad_entrega" class="form-control">
                    <option disabled value="">Seleccione un estado</option>
                    <option>ACEPTADO</option>
                    <option>RECHAZADO</option>
                    <option>EN CUSTODIA</option>
                    <option>CANCELADO</option>
                  </select>
                </div>
              </div>

              <div class="form-group mt-2" v-if="nuevoEstado != 8">
                <label for="archivo">¿Qué archivo?</label>
                <select v-model="nuevoArchivo.tipo" class="form-control" id="archivo">
                  <option value="">-- Selecciona un archivo --</option>
                  <option v-for="(opcion, index) in opcionesFiltradas" :key="index" :value="opcion">
                    {{ opcion }}
                  </option>
                </select>
              </div>
              <div class="col-md-12" v-if="nuevoEstado != 8">
                <label class="form-label">Comentario</label>
                <textarea v-model="nuevoArchivo.comentario" class="form-control" rows="2"></textarea>
              </div>
            </div>

            <!-- Drag & Drop Zone -->
            <div   v-if="nuevoEstado != 8" class="dropzone mt-3" @dragover.prevent="dragging = true" @dragleave.prevent="dragging = false"
              @drop.prevent="soltarArchivo" @click="abrirExplorador">
              <div v-if="!nuevoArchivo.nombre" class="dropzone-content">
                <i class="fas fa-cloud-upload-alt fa-3x"></i>
                <p>Arrastra un archivo aquí o haz clic para seleccionar</p>
                <input type="file" class="d-none" ref="fileInput" @change="seleccionarArchivo" />
              </div>
              <div v-else class="dropzone-preview">
                <img v-if="esImagen(nuevoArchivo.nombre)" :src="nuevoArchivo.url" class="img-thumbnail" width="100" />
                <p>{{ nuevoArchivo.nombre }}</p>
              </div>
            </div>
            <div v-if="nuevoEstado == 8">
              <p class="p-3 text-danger">AHORA SUBE TU CARGO ESCANEADO POR GESTIÓN DE CARGOS</p>
            </div>
            <br>
            <button @click="gestionEstado()" class="btn btn-primary btn-sm float-end">Actualizar Estado</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para subir archivos -->
    <div v-if="showModalArchivos" class="modal fade show d-block" tabindex="-1">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="uploadModalLabel">Documentos</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" @click="showModalArchivos = false"
              aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <!-- Tabla con los documentos agregados -->
            <div class="mt-4">
              <table class="table table-font-small">
                <thead>
                  <tr>
                    <th>Tipo de Documento</th>
                    <th>Archivo</th>
                    <th>Comentario</th>
                    <th class="col-acciones">Acciones</th>
                  </tr>
                </thead>
                <tbody class="table-border-bottom-0 padding-custom">
                  <tr v-for="(archivo, index) in archivos" :key="index">
                    <td v-if="archivo.nombre">{{ archivo.tipo }}</td>
                    <td v-if="archivo.nombre">
                      <span v-if="esImagen(archivo.nombre)">
                        <img :src="archivo.url" class="img-thumbnail" width="50" />
                      </span>
                      {{ archivo.nombre }}
                    </td>
                    <td v-if="archivo.nombre">{{ archivo.comentario }}</td>
                    <td v-if="archivo.nombre" class="col-acciones">
                      <button class="btn-icon btn-icon-view" @click="verArchivo(archivo)" title="Ver archivo" aria-label="Ver archivo"><i class="bi bi-eye"></i></button>
                      <button v-if="esSuperAdmin()" class="btn-icon btn-icon-del" @click="eliminarArchivo(archivo.id)" title="Eliminar archivo" aria-label="Eliminar archivo"><i class="bi bi-trash"></i></button>
                    </td>
                  </tr>
                  <tr v-if="archivos.length === 0" class="empty-row"><td colspan="4">No hay archivos subidos</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Gestión de Guías -->
    <div v-if="showModalGestionGuias" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
      <!-- scrollable para envíos con muchos cargos -->
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"><i class="bi bi-file-earmark-text me-2"></i>Gestión de Cargos</h5>
            <button type="button" class="btn-close" @click="showModalGestionGuias = false"></button>
          </div>
          <div class="modal-body">
            <div class="d-flex flex-wrap align-items-center gap-2 mb-3">
              <span class="text-muted small">Envío</span>
              <span class="badge bg-primary fs-6 fw-semibold">{{ envioSeleccionadoGuias?.rastreo }}</span>
              <span v-if="envioSeleccionadoGuias?.detalles?.length" class="badge bg-light text-dark border">
                {{ envioSeleccionadoGuias.detalles.length }} {{ envioSeleccionadoGuias.detalles.length === 1 ? 'cargo' : 'cargos' }}
              </span>
            </div>
            <div v-if="envioSeleccionadoGuias && envioSeleccionadoGuias.detalles && envioSeleccionadoGuias.detalles.length">
              <div class="table-responsive">
                <table class="table table-bordered table-sm table-hover align-middle">
                  <thead class="table-primary text-center" style="font-size:0.82rem;">
                    <tr>
                      <th>Detalle Método Envío</th>
                      <th>Factura</th>
                      <th>N° OTM</th>
                      <th>Orden Compra</th>
                      <th>Documentos Extras</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody style="font-size:0.85rem;">
                    <tr v-for="detalle in envioSeleccionadoGuias.detalles" :key="detalle.id">
                      <td>{{ detalle.detalle_metodo_envio || '-' }}</td>
                      <td>{{ detalle.numero_factura || '-' }}</td>
                      <td>{{ detalle.otm || '-' }}</td>
                      <td>{{ detalle.orden_compra || '-' }}</td>
                      <td>{{ detalle.documentos_extras || '-' }}</td>
                      <td class="text-center" style="white-space:nowrap;">
                        <button v-if="detalle.archivo_url" class="btn btn-sm btn-info me-2" @click="verArchivoGuia(detalle.archivo_url)">
                          <i class="bi bi-eye"></i> Ver
                        </button>
                        <button class="btn btn-sm btn-primary" v-if="esSuperAdminOInterno()"  @click="subirArchivoGuia(detalle)"><i class="bi bi-upload"></i> Subir archivo</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else class="text-muted">No hay detalles de guías para este envío.</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para Subir Archivos de Guía -->
    <div v-if="showModalArchivoGuia" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"><i class="bi bi-cloud-arrow-up me-2"></i>Subir archivo del documento</h5>
            <button type="button" class="btn-close" @click="cerrarModalArchivoGuia"></button>
          </div>
          <div class="modal-body">
            <!-- Datos del documento: solo los que tiene -->
            <div v-if="detalleGuiaSeleccionado && referenciasGuia(detalleGuiaSeleccionado).length" class="guia-refs">
              <div v-for="ref in referenciasGuia(detalleGuiaSeleccionado)" :key="ref.label" class="guia-ref">
                <span class="guia-ref-label">{{ ref.label }}</span>
                <span class="guia-ref-valor">{{ ref.valor }}</span>
              </div>
            </div>
            <!-- El tipo de archivo es fijo: se muestra como dato, no como select bloqueado -->
            <div class="guia-tipo">
              <i class="bi bi-file-earmark-pdf"></i>
              <div>
                <div class="guia-tipo-nombre">{{ archivoGuia.tipo }}</div>
                <div class="guia-tipo-detalle">PDF (escaneo o foto en PDF)</div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-md-12">
                <label class="form-label">Comentario <span class="guia-opcional">(opcional)</span></label>
                <textarea v-model="archivoGuia.comentario" class="form-control" rows="2"
                  placeholder="Algún detalle sobre el archivo"></textarea>
              </div>
            </div>

            <!-- Drag & Drop Zone para Guía -->
            <div class="dropzone mt-3" 
                 :class="{ 'drop-hover': draggingGuia }"
                 @dragover.prevent="draggingGuia = true" 
                 @dragleave.prevent="draggingGuia = false"
                 @drop.prevent="soltarArchivoGuia" 
                 @click="abrirExploradorGuia">
              <div v-if="!archivoGuia.nombre" class="dropzone-content">
                <i class="fas fa-cloud-upload-alt fa-3x"></i>
                <p>Arrastra un archivo aquí o haz clic para seleccionar</p>
                <input type="file" class="d-none" ref="fileInputGuia" @change="seleccionarArchivoGuia" />
              </div>
              <div v-else class="dropzone-preview">
                <img v-if="esImagen(archivoGuia.nombre)" :src="archivoGuia.url" class="img-thumbnail" width="100" />
                <p><strong>{{ archivoGuia.nombre }}</strong></p>
                <button class="btn btn-sm btn-outline-secondary mt-2" @click.stop="limpiarArchivoGuia">
                  <i class="bi bi-x-circle"></i> Cambiar archivo
                </button>
              </div>
            </div>

            <p v-if="!archivoGuia.archivo" class="guia-hint">Selecciona el archivo para poder subirlo.</p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="cerrarModalArchivoGuia">Cancelar</button>
            <button class="btn btn-primary" @click="guardarArchivoGuia" :disabled="!archivoGuia.archivo">
              <i class="bi bi-upload me-1"></i> Subir archivo
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import { validarRangoFechas, LIMITE_EXPORTACION, mensajeErrorDescarga } from '@/utils/rangoFechas'
import moment from 'moment'
import ShippingANWLocalDocument from '@/components/ShippingANWLocalDocument.vue'
import PaginacionListado from '@/components/PaginacionListado.vue'

export default {
  name: 'ShippingLocalDocumentListPage',
  components: {
    ShippingANWLocalDocument,
    PaginacionListado
  },
  data() {
    return {
      isLoading: true,
      exportando: false,
      user: {},
      tipoEnvio: this.$route.params.tipo_envio,
      modalDetalle: false,
      showModalArchivos: false,
      modalGestionANW: false,
      estadosEnvio: [],
      modalEstados: false,
      cantidad_bultos_origen: '',
      cantidad_bultos_destino: '',
      estado_bultos_origen: '',
      estado_bultos_destino: '',
      conformidad_entrega: '',
      conformidad_draeger:'SIN RECEPCIONAR',
      nuevoEstado: '',
      envioId: null,
      tipoArchivo: '',
      archivoSeleccionado: '',
      codigosMetodoEnvio: [],
      opciones: {
        fotos: [
          'Foto de documentos en origen',
          'Foto del punto de recojo (opcional, para incidentes o validación)',
          'Foto de documentos en el cliente',
          'Foto de bultos dañados (si aplica)',
          'Foto del cargo entregado en oficina (DRAEGER)',
          'Foto de acceso bloqueado o incidente en ruta',
          'Foto del tráfico o desvíos durante tránsito',
          'Foto de rechazo (cuando el cliente no acepta la entrega)',
          'Otros'
        ],
        videos: [
          'Video de los documentos en origen (muestra condiciones)',
          'Video durante la ruta (incidente, tráfico o desvío)',
          'Video del estado de los documentos al llegar a destino',
          'Otros'
        ],
        pdf: [
          'Cargo firmado por el cliente (en destino)',
          'Formato de recojo (si aplica)',
          'Cargo de entrega en agencia',
          'Acta de entrega (si aplica)',
          'Formato de devolución o rechazo firmado',
          'Documento adicional solicitado por Draeger'
        ]
      },
      filtros: {
        tipo_paquete: "documentos",
        ruc: '',
        razon_social: '',
        cliente_final: '',
        pedido: '',
        guia: '',
        otm:'',
        serie_guia: '',
        fecha_inicio: '',
        fecha_fin: '',
        id_modalidades_envio: '',
        modalidad_envio:'',
        estado_entrega: ''
      },
      comentario: '',
      detalleEnvio: {},
      envios: [],
      pagina: 1,
      porPagina: 25,
      totalPaginas: 1,
      totalEnvios: 0,
      empresas: [
        { id: 1, nombre: 'Empresa A' },
        { id: 2, nombre: 'Empresa B' },
      ],
      tipoUnidades: [
        { id: 3, tipo_unidad: 'Camión 10T' },
        { id: 4, tipo_unidad: 'Camión 20T' },
      ],
      archivos: [],
      nuevoArchivo: {
        tipo: '',
        archivo: null,
        nombre: '',
        comentario: '',
        url: null,
      },
      dragging: false,
      envioSeleccionadoGuias: null,
      showModalGestionGuias: false,
      showModalArchivoGuia: false,
      detalleGuiaSeleccionado: null,
      archivoGuia: {
        tipo: '',
        archivo: null,
        nombre: '',
        comentario: '',
        url: null,
      },
      tipoArchivoGuia: '',
      draggingGuia: false,
    }
  },
  watch: {
    '$route.path'() {
      this.limpiarFiltros()
      this.tipoEnvio = this.$route.params.tipo_envio
      if (this.tipoEnvio == 'exclusivos') {
        this.filtros.id_modalidades_envio = 3
      } else if (this.tipoEnvio == 'consolidados') {
        this.filtros.id_modalidades_envio = 2
      } else if (this.tipoEnvio == 'aereos') {
        this.filtros.id_modalidades_envio = 4
      }
      this.buscarEnvios()
    },
  },
  computed: {
    rutaEnvio() {
      return 'envios-locales-emergencias';
    },
    opcionesFiltradas() {
      return this.tipoArchivo ? this.opciones[this.tipoArchivo] : [];
    }
  },
  mounted() {
    this.getEstadosEnvio()
    this.buscarEnvios()
    this.getCodigoMetodoEnvio()
    this.user = JSON.parse(localStorage.getItem('user'))
  },
  methods: {

    esAdmin() {
      const cargo = this.user?.cargo?.toLowerCase()
      return cargo === 'admin' || cargo === 'admin-draeger'
    },
    esSuperAdminOInterno() {
      console.log("this.user", this.user)
      return this.user?.cargo?.toLowerCase() === 'admin' || this.user?.tipo_usuario == 'interno'
    },
    esSuperAdmin() {
      return this.user?.cargo?.toLowerCase() === 'admin'
    },
    formatHoraAMPM(hora) {
      return moment(hora, 'HH:mm:ss').format('hh:mm A');
    },
    async getCodigoMetodoEnvio() {
      try {
        const response = await axios.get('cod-metodo-envio')
        this.codigosMetodoEnvio = response.data // Usar response.data
      } catch (error) {
        console.error('Error cargando códigos de método de envío:', error)
      }
    },
    getTipoEnvioTexto() {
      switch (this.tipoEnvio) {
        case 'exclusivos':
          return 'Exclusivos'
        case 'consolidados':
          return 'Consolidados'
        case 'aereos':
          return 'Aéreos'
        default:
          return 'Desconocido'
      }
    },
    async exportarExcel() {
      const errorRango = validarRangoFechas(this.filtros.fecha_inicio, this.filtros.fecha_fin, LIMITE_EXPORTACION);
      if (errorRango) {
        Swal.fire({ icon: 'info', title: 'Ajusta el rango de fechas', text: errorRango });
        return;
      }
      if (this.exportando) return; // ya hay una exportación en curso
      this.exportando = true;
      try {
        const response = await axios.get('/exportar-envios-local-documentos', {
          params: this.filtros,
          responseType: 'blob'
        });

        // Generar nombre dinámico: provincia_mercaderia_YYYYmmddHHMMss.xlsx
        const now = new Date();
        const pad = (n) => n.toString().padStart(2, '0');
        const fileName = `local_documentos_${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}.xlsx`;

        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error('Error al exportar:', error);
        Swal.fire({
          icon: 'error',
          title: 'No se pudo exportar',
          text: await mensajeErrorDescarga(error, 'Ocurrió un error al generar el archivo. Intenta nuevamente.'),
        });
      } finally {
        this.exportando = false;
      }
    },
    async getEstadosEnvio() {
      this.isLoading = true;
      const { data } = await axios.get('estados-envio-local')
      this.estadosEnvio = data
      if (this.user.cargo != "admin-draeger" && this.user.cargo != "admin" && this.user.tipo_usuario != "interno" ) {
        this.estadosEnvio = this.estadosEnvio.filter(item => [15, 10].includes(item.id));
      }
      this.isLoading = false;
    },
    formatFecha(fecha) {
      if (!fecha) return ''
      const [year, month, day] = fecha.split('-')
      return new Date(year, month - 1, day).toLocaleDateString('es-PE', {
        dateStyle: 'short',
      })
    },
    editarEnvio(envio) {
      this.$router.push(`/editar-envio-local-documento/${envio.id_envio_local}`)
    },
    async guardarGestion() {
      try {
        const resultado = await this.$refs.shippingANWRef.submitDesdePadre();
        console.log('Resultado desde el hijo:', resultado);
      } catch (error) {
        console.error('Error al guardar desde el hijo:', error);
      }
    },



    openEstadoEnvio(item) {
      this.detalleEnvio = { ...item }
      this.nuevoEstado = this.detalleEnvio.estado_entrega
      this.cantidad_bultos_origen = this.detalleEnvio.cantidad_bultos_origen
      this.estado_bultos_origen = this.detalleEnvio.estado_bultos_origen
      this.cantidad_bultos_destino = this.detalleEnvio.cantidad_bultos_destino
      this.estado_bultos_destino = this.detalleEnvio.estado_bultos_destino,
        this.conformidad_entrega = this.detalleEnvio.conformidad_entrega,
        this.modalEstados = true
    },
    async eliminarEnvio(envio) {
      const confirmacion = await Swal.fire({
        title: '¿Estás seguro?',
        text: `Vas a eliminar el envío ${envio.rastreo || ''}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#d33',
        cancelButtonColor: '#6c757d',
      });

      if (confirmacion.isConfirmed) {
        try {
          // Aquí llamás a tu endpoint para eliminar
          await axios.delete(`/envios-locales/${envio.id_envio_local}`);

          // Mensaje de éxito
          await Swal.fire({
            icon: 'success',
            title: 'Eliminado',
            text: 'El envío fue eliminado correctamente.',
            timer: 1500,
            showConfirmButton: false,
          });

          // Recargar lista (si lo necesitas)
          this.buscarEnvios(); // o como se llame tu método para recargar

        } catch (error) {
          console.error(error);
          
          // Obtener el mensaje de error del servidor
          let errorMessage = 'Hubo un problema al eliminar el envío.';
          if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
          }
          
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: errorMessage,
          });
        }
      }
    },
    async gestionEstado() {
      console.log("nuevoEstado", this.nuevoEstado);

      let data = {
        id_envio_local: this.detalleEnvio.id_envio_local,
        estado_entrega: this.nuevoEstado,
        conformidad_draeger: this.conformidad_draeger
      };

      try {
        await axios.post(`estado-envio-local`, data);
        await this.agregarArchivo();
        this.cargarArchivos(this.detalleEnvio.id_envio_local);
        this.buscarEnvios();
        Swal.fire({
          icon: 'success',
          title: 'Estado Actualizado',
          text: 'El estado se ha actualizado correctamente.',
        });
        
        // Limpiar el formulario del modal
        this.limpiarFormularioModal();
        this.modalEstados = false;
      } catch (error) {
        console.error(`Error al actualizar el estado del envío`, error);
      }
    },
    limpiarFormularioModal() {
      // Reiniciar los campos del formulario
      this.nuevoEstado = '';
      this.tipoArchivo = '';
      this.cantidad_bultos_origen = '';
      this.cantidad_bultos_destino = '';
      this.estado_bultos_origen = '';
      this.estado_bultos_destino = '';
      this.conformidad_entrega = '';
      this.nuevoArchivo = {
        tipo: '',
        archivo: null,
        nombre: '',
        comentario: '',
        url: null,
      };
      
      // Limpiar el input file si existe
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    },

    async agregarArchivo() {
      // Solo intentar subir archivo si hay un archivo seleccionado
      // if (!this.nuevoArchivo.archivo || !this.nuevoArchivo.tipo) {
      //   console.log('No hay archivo o tipo seleccionado, omitiendo subida de archivo');
      //   return;
      // }

      const formData = new FormData()
      formData.append('envio_id', this.detalleEnvio.id_envio_local)
      formData.append('tipo', this.nuevoArchivo.tipo)
      formData.append('archivo', this.nuevoArchivo.archivo)
      formData.append('comentario', this.nuevoArchivo.comentario)
      formData.append('id_estados_envio_local', this.nuevoEstado)

      try {
        const { data } = await axios.post('/subir-archivo-local', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        this.archivos.push(data)
        this.nuevoArchivo = {
          tipo: '',
          archivo: null,
          nombre: '',
          comentario: '',
        }
      } catch (error) {
        console.error('Error al subir archivo', error)
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo subir el archivo. Inténtelo de nuevo.',
        })
      }
    },

    mostrarDetalle(item) {
      this.modalDetalle = true
      this.detalleEnvio = { ...item }
    },
    cerrarDetalle() {
      this.modalDetalle = false
    },
    abrirGestionarModal(item) {
      this.detalleEnvio = item;
      console.log("detalleEnvio", this.detalleEnvio)
      this.modalGestionANW = true
    },
    obtenerNombreEmpresa(id) {
      return this.empresas.find((e) => e.id === id)?.nombre || 'No especificado'
    },
    obtenerTipoUnidad(id) {
      return (
        this.tipoUnidades.find((t) => t.id === id)?.tipo_unidad ||
        'No especificado'
      )
    },
    async buscarEnvios() {
      this.isLoading = true;

      try {
        const { data } = await axios.get('envios-locales', { params: { ...this.filtros, page: this.pagina } })
        // Si la página quedó fuera de rango (p. ej. al eliminar el último envío de la última página), ir a la última
        if (data.data.length === 0 && data.total > 0 && this.pagina > data.last_page) {
          this.pagina = data.last_page
          return this.buscarEnvios()
        }
        this.envios = data.data
        this.totalPaginas = data.last_page
        this.totalEnvios = data.total
      } catch (error) {
        console.error('Error al buscar envíos', error)
      } finally {
        this.isLoading = false;
      }
    },
    aplicarFiltros() {
      this.pagina = 1
      this.buscarEnvios()
    },
    cambiarPagina(n) {
      this.pagina = n
      this.buscarEnvios()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    async aceptarEnvio() {
      await this.actualizarEnvio('aceptar')
    },

    async rechazarEnvio() {
      await this.actualizarEnvio('rechazar')
    },
    async actualizarEnvio(accion) {
      try {
        await axios.get(`${accion}-envio/${this.detalleEnvio.id_envio}`)
        this.cerrarDetalle()
        this.buscarEnvios()
        Swal.fire({
          icon: 'success',
          title: 'Envío Actualizado',
          text: 'Los datos se han actualizado correctamente.',
        })
      } catch (error) {
        console.error(`Error al ${accion} envío`, error)
      }
    },
    getBadgeClass(estado) {
      const badgeMap = {
        1: 'bg-secondary', // Solicitud Recibida
        2: 'bg-success',   // Aprobada
        3: 'bg-info',    // Programado para ruta
        4: 'bg-warning',   // En espera
        5: 'bg-info',      // Recojo en curso
        6: 'bg-success',   // Recojo confirmado
        7: 'bg-warning',   // Embarque/Despacho
        8: 'bg-info',      // Traslado en curso
        9: 'bg-primary',   // Llegada a destino
        10: 'bg-info',     // Entrega en curso
        11: 'bg-success',  // Entregado
        12: 'bg-primary',  // Cargo PDF
        13: 'bg-danger',  // Cargo Físico Confirmado
        14: 'bg-warning',   // Servicio Reprogramado(ANW)
        15: 'bg-danger',  // Cancelado        
      };

      return `badge ${badgeMap[estado] || 'bg-secondary'} breakable-badge`;
    },
    limpiarFiltros() {
      Object.keys(this.filtros).forEach(
        (key) =>
          (this.filtros[key] = key === 'id_modalidades_envio' ? '3' : ''),
      )
      this.filtros.tipo_paquete = 'documentos' // sin esto "Limpiar" pedía tipo_paquete vacío y no traía nada
      this.pagina = 1
      this.buscarEnvios()
    },

    abrirCargarArchivosModal(envio) {
      this.envioId = envio.id_envio_local
      this.cargarArchivos(envio.id_envio_local)
      this.showModalArchivos = true
    },
    seleccionarArchivo(event) {
      this.procesarArchivo(event.target.files[0])
    },
    abrirExplorador() {
      this.$refs.fileInput.click()
    },
    soltarArchivo(event) {
      this.dragging = false
      this.procesarArchivo(event.dataTransfer.files[0])
    },
    procesarArchivo(file) {
      if (file) {
        this.nuevoArchivo = {
          ...this.nuevoArchivo,
          archivo: file,
          nombre: file.name,
          url: URL.createObjectURL(file),
        }
      }
    },


    async cargarArchivos(envioId) {
      try {
        const { data } = await axios.get(`/archivos-local/${envioId}`)
        this.archivos = data
      } catch (error) {
        console.error('Error al obtener archivos', error)
      }
    },
    verArchivo(archivo) {
      window.open(archivo.url, '_blank')
    },
    async eliminarArchivo(id) {
      const result = await Swal.fire({
        title: '¿Estás seguro?',
        text: 'Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      })

      if (result.isConfirmed) {
        try {
          await axios.delete(`/eliminar-archivo-local/${id}`)
          this.cargarArchivos(this.envioId)

          Swal.fire({
            icon: 'success',
            title: 'Eliminado',
            text: 'El archivo ha sido eliminado correctamente.',
            confirmButtonText: 'OK',
          })
        } catch (error) {
          console.error('Error al eliminar archivo', error)

          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No se pudo eliminar el archivo.',
            confirmButtonText: 'OK',
          })
        }
      }
    },

    esImagen(nombre) {
      return /\.(jpg|jpeg|png|gif)$/i.test(nombre)
    },
    abrirGestionGuiasModal(envio) {
      this.envioSeleccionadoGuias = envio;
      this.showModalGestionGuias = true;
    },
    // Datos del documento para el modal de subida (solo los que tienen valor)
    referenciasGuia(detalle) {
      return [
        { label: 'Método de envío', valor: detalle.detalle_metodo_envio },
        { label: 'Factura', valor: detalle.numero_factura },
        { label: 'OTM', valor: detalle.otm },
        { label: 'Orden de compra', valor: detalle.orden_compra },
      ].filter(ref => ref.valor)
    },
    subirArchivoGuia(detalle) {
      this.detalleGuiaSeleccionado = detalle;
      this.limpiarArchivoGuia();
      this.showModalArchivoGuia = true;
    },
    cerrarModalArchivoGuia() {
      this.showModalArchivoGuia = false;
      this.detalleGuiaSeleccionado = null;
      this.limpiarArchivoGuia();
    },
    limpiarArchivoGuia() {
      this.archivoGuia = {
        tipo: 'Cargo firmado por el cliente (en destino)',
        archivo: null,
        nombre: '',
        comentario: '',
        url: null,
      };
      this.tipoArchivoGuia = 'pdf';
      this.draggingGuia = false;
    },
    seleccionarArchivoGuia(event) {
      this.procesarArchivoGuia(event.target.files[0]);
    },
    abrirExploradorGuia() {
      this.$refs.fileInputGuia.click();
    },
    soltarArchivoGuia(event) {
      this.draggingGuia = false;
      this.procesarArchivoGuia(event.dataTransfer.files[0]);
    },
    procesarArchivoGuia(file) {
      if (file) {
        this.archivoGuia = {
          ...this.archivoGuia,
          archivo: file,
          nombre: file.name,
          url: URL.createObjectURL(file),
        };
      }
    },
    async guardarArchivoGuia() {
      if (!this.archivoGuia.archivo) {
        Swal.fire({
          icon: 'warning',
          title: 'Campo requerido',
          text: 'Debes seleccionar un archivo.',
        });
        return;
      }

      const formData = new FormData();
      formData.append('envio_id', this.envioSeleccionadoGuias.id_envio_local);
      formData.append('tipo', this.archivoGuia.tipo);
      formData.append('archivo', this.archivoGuia.archivo);
      formData.append('comentario', this.archivoGuia.comentario);
      formData.append('id_estados_envio_local', 8);
      formData.append('id_envio_local_detalle', this.detalleGuiaSeleccionado.id);

      try {
        await axios.post('/subir-archivo-local', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        // Actualizar el listado de envíos para reflejar los cambios
        await this.buscarEnvios();

        // Actualizar el envío seleccionado con la nueva información
        const envioActualizado = this.envios.find(envio => envio.id_envio_local === this.envioSeleccionadoGuias.id_envio_local);
        if (envioActualizado) {
          this.envioSeleccionadoGuias = envioActualizado;
        }

        Swal.fire({
          icon: 'success',
          title: 'Archivo subido',
          text: 'El archivo se ha subido correctamente.',
        });

        // Cerrar el modal de subir archivo pero mantener el de gestión de guías
        this.cerrarModalArchivoGuia();
      } catch (error) {
        console.error('Error al subir archivo de guía', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo subir el archivo. Inténtelo de nuevo.',
        });
      }
    },
    verArchivoGuia(archivoUrl) {
      window.open(archivoUrl, '_blank');
    },
  },
}
</script>

<style scoped>
.modal.fade.show {
  display: block;
}

.modal.show {
  background: rgba(0, 0, 0, 0.5);
}


.badge {
  font-size: 14px;
  padding: 6px 10px;
  border-radius: 5px;
}

.table-font-small {
  font-size: 0.75rem;
}

.table {
  width: 100%;
}

.table th,
.table td {
  white-space: normal;
  /* Permite saltos de línea */
  /* Oculta el exceso de contenido */
  text-overflow: ellipsis;
  /* Mantiene los puntos suspensivos si el contenido es demasiado grande */
  word-wrap: break-word;
  /* Rompe palabras largas si es necesario */
  overflow-wrap: break-word;
  /* Alternativa moderna */
  text-align: center;
  vertical-align: middle;
}

@media (min-width: 768px) {
  .table {
    width: 100%;
  }

  .table-responsive {
    overflow: visible !important;
    /* Permite que el dropdown no se esconda */
  }
}

.dropdown-menu {
  min-width: 180px;
}

.dropdown-item i {
  margin-right: 8px;
}

.custom-dropdown {
  position: absolute !important;
  /* Permite que se desplace sobre otras filas */
  z-index: 1050 !important;
  /* Asegura que esté sobre otros elementos */
  left: auto !important;
  /* Evita que se recorte en la tabla */
  right: 0 !important;
  /* Alinea correctamente */
}


.dropdown-menu.show {
  position: absolute !important;
  z-index: 1050 !important;
  will-change: transform;
}

.dropzone {
  border: 2px dashed #007bff;
  padding: 20px;
  text-align: center;
  border-radius: 10px;
  cursor: pointer;
  transition: 0.3s;
}

.dropzone:hover,
.dropzone.drop-hover {
  background: rgba(0, 123, 255, 0.1);
}

.dropzone-content i {
  color: #007bff;
}

.dropzone-preview img {
  max-width: 100px;
  margin-top: 10px;
}

.swal2-container {
  z-index: 9999 !important;
}

.badge {
  font-size: 10px;
  padding: 4px 8px;
  border-radius: 5px;
  line-height: 1.2;
}

.breakable-badge {
  white-space: normal;
  word-break: break-word;
}

/* Detalle */
</style>
